import React from 'react'

const defaultStyles = {strokeLinecap: 'round', strokeLinejoin: 'round', strokeWidth: '1px'}

const defaultSVGProps = {
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink"
}

export class SvgIcon extends React.Component {

  getPath(name){
    switch (name) {
      case "icon-logo-gem":
        return ( <CmGemIcon color={this.props.color} /> )
      case "icon-message-sent":
        return ( <MessageSentIcon color={this.props.color} />)
      case "icon-facebook":
        return ( <FacebookIcon color={this.props.color} />)
      case "icon-instagram":
        return ( <InstagramIcon color={this.props.color} />)
      case "icon-twitter":
        return ( <TwitterIcon color={this.props.color} />)
      case "icon-arrow":
        return ( <ArrowIcon {...this.props} />)
      default:
        return ( <span></span> )
    }
  }

  getViewBox(name){
    switch (name) {
      case "icon-logo-gem":
        return "0 0 151 110"
      case "icon-facebook":
      case "icon-instagram":
      case "icon-twitter":
        return "0 0 24 24"
      default:
        return "0 0 128 128"
    }
  }

  render(){

    let path = this.getPath(this.props.name)
    let viewBox = this.getViewBox(this.props.name)

    return(
      <svg id={this.props.name} data-name={this.props.name} viewBox={viewBox} version="1.1" xmlns="http://www.w3.org/2000/svg" height={this.props.size} width="100%" xmlnsXlink="http://www.w3.org/1999/xlink" className={this.props.className ? this.props.className : ''}>
        {path}
      </svg>
      )
  }
}


//Main Gem Icon for the logo
class CmGemIcon extends React.Component {
  render(){

    return(
          <g id="Page-1" stroke="none" strokeWidth="1" fillRule="evenodd">
              <g id="CustomMade_New-Logo_Gem-01" fillRule="nonzero" fill={this.props.color}>
                  <g id="CM_Gem_Icon" transform="translate(0.760683, 0.229450)">
                      <path d="M52.2393175,15.9005496 C53.0461229,16.6675353 54.312512,16.6675353 55.1193175,15.9005496 L68.1193175,3.35054957 L68.1193175,3.35054957 C68.6970974,2.79832455 68.8723554,1.94593341 68.5593175,1.21054957 C68.2345572,0.465825327 67.4915509,-0.00843405839 66.6793175,0.0105495706 L40.5993175,0.0105495706 C39.7882881,-0.00264116177 39.0496092,0.475327541 38.7293175,1.22054957 C38.4087162,1.95193966 38.5851541,2.80605922 39.1693175,3.35054957 L52.2393175,15.9005496 Z"></path>
                      <path d="M61.1493175,24.5105496 L71.0893175,34.0805496 C71.4716436,34.4598857 71.990803,34.6689915 72.5293175,34.6607956 C73.064794,34.6629921 73.5805836,34.4588254 73.9693175,34.0905496 L105.879317,3.34054957 L105.879317,3.34054957 C106.457097,2.78832455 106.632355,1.93593341 106.319317,1.20054957 C105.994557,0.455825327 105.251551,-0.0184340584 104.439317,0.000549570564 L84.5393175,0.000549570564 C84.0072952,0.000674771668 83.4955452,0.204659021 83.1093175,0.570549571 L61.1393175,21.7705496 C60.7595816,22.1311607 60.5445646,22.6318705 60.5445646,23.1555496 C60.5445646,23.6792286 60.7595816,24.1799384 61.1393175,24.5405496"></path>
                      <path d="M32.1393175,8.28054957 C31.3244302,7.54397477 30.0842048,7.54397477 29.2693175,8.28054957 L0.599317487,35.8905496 C0.216906157,36.2496801 2.84217094e-14,36.750942 2.84217094e-14,37.2755496 C2.84217094e-14,37.8001572 0.216906157,38.3014191 0.599317487,38.6605496 L73.5093175,108.89055 C74.3107067,109.66139 75.5779283,109.66139 76.3793175,108.89055 L105.069317,81.2605496 C105.446423,80.898494 105.65959,80.3983233 105.65959,79.8755496 C105.65959,79.3527758 105.446423,78.8526051 105.069317,78.4905496 L32.1393175,8.28054957 Z"></path>
                      <path d="M106.149317,42.0505496 C105.992436,41.9066081 105.903127,41.7034603 105.903127,41.4905496 C105.903127,41.2776388 105.992436,41.074491 106.149317,40.9305496 L128.869317,19.0205496 C129.254262,18.6610602 129.471736,18.1572458 129.469337,17.6305496 C129.46803,17.1095528 129.255072,16.6114479 128.879317,16.2505496 L118.179317,5.94054957 C117.368555,5.18353441 116.11008,5.18353441 115.299317,5.94054957 L80.0393175,39.9405496 C79.6569062,40.2996801 79.44,40.800942 79.44,41.3255496 C79.44,41.8501572 79.6569062,42.3514191 80.0393175,42.7105496 L111.139317,72.7105496 C111.942765,73.4762641 113.20587,73.4762641 114.009317,72.7105496 L124.509317,62.5905496 C124.894262,62.2310602 125.111736,61.7272458 125.109317,61.2005496 C125.10803,60.6795528 124.895072,60.1814479 124.519317,59.8205496 L106.149317,42.0505496 Z"></path>
                      <path d="M149.239317,35.9005496 L137.779317,24.9005496 C136.961138,24.1625862 135.717497,24.1625862 134.899317,24.9005496 L119.099317,40.1505496 C118.720127,40.5094031 118.505304,41.0084753 118.505304,41.5305496 C118.505304,42.0526238 118.720127,42.551696 119.099317,42.9105496 L130.539317,53.9105496 C130.924723,54.2851813 131.441844,54.4934659 131.979317,54.4905798 C132.515981,54.4892663 133.031585,54.2815922 133.419317,53.9105496 L149.239317,38.6705496 C149.621729,38.3114191 149.838635,37.8101572 149.838635,37.2855496 C149.838635,36.760942 149.621729,36.2596801 149.239317,35.9005496"></path>
                  </g>
              </g>
          </g>
      )
  }
}

class MessageSentIcon extends React.Component {
  render(){
    return(
        <g stroke={this.props.color} fill="none" style={defaultStyles}>
          <path d="M32,53.35a1,1,0,0,0,1,1H43.91a1,1,0,0,0,0-2H33A1,1,0,0,0,32,53.35Z" />
          <path d="M53.45,63.89a1,1,0,0,0-1-1H41.14a1,1,0,0,0,0,2H52.45A1,1,0,0,0,53.45,63.89Z" />
          <path d="M29.05,64a1,1,0,0,0,1,1h5.63a1,1,0,1,0,0-2H30.05A1,1,0,0,0,29.05,64Z" />
          <path d="M13.9,72.59a1,1,0,0,0,0,2h5.45a1,1,0,0,0,0-2Z"/>
          <path d="M24.81,74.59H41.06a1,1,0,0,0,0-2H24.81a1,1,0,0,0,0,2Z"/>
          <path d="M25.81,64a1,1,0,0,0-1-1H9.22a1,1,0,0,0,0,2H24.81A1,1,0,0,0,25.81,64Z" />
          <path d="M26.76,54.35a1,1,0,0,0,0-2H23a1,1,0,1,0,0,2Z" />
          <path d="M35.61,92.27h79.17a5,5,0,0,0,5-5V59.42a1,1,0,1,0-2,0V87.27a3,3,0,0,1-3,3H35.61a3,3,0,0,1-3-3V81.59a1,1,0,0,0-2,0v5.68A5,5,0,0,0,35.61,92.27Z" />
          <path d="M119.78,36.58a5,5,0,0,0-5-5H35.61a5,5,0,0,0-5,5v8.18a1,1,0,1,0,2,0V36.58a3,3,0,0,1,3-3h79.17a3,3,0,0,1,1.58.46l-36,23.29A1,1,0,0,0,81,59.17a1,1,0,0,0,.54-.16l36.12-23.39a3,3,0,0,1,.17,1V50.76a1,1,0,0,0,2,0Z"/>
          <path d="M105.61,82.42a1,1,0,0,0,.54-1.84L75.74,61.08a1,1,0,0,0-.48-.14L43.49,40.58a1,1,0,0,0-1.39.3,1,1,0,0,0,.31,1.38L73.09,61.92l-29.68,19a1,1,0,0,0-.31,1.38,1,1,0,0,0,.85.47,1.09,1.09,0,0,0,.54-.16L75.07,63l30,19.23A1,1,0,0,0,105.61,82.42Z"/>
          <path d="M62.2,81.17a1,1,0,0,0,0,2H76.7a1,1,0,0,0,0-2Z" />
          <path d="M83,81.17a1,1,0,0,0,0,2h6.5a1,1,0,0,0,0-2Z" />
        </g>
      )
  }
}

class FacebookIcon extends React.Component {
  render(){

    return(
        <g fill={this.props.color} >
          <path d="M22.676 0H1.324C.593 0 0 .593 0 1.324v21.352C0 23.408.593 24 1.324 24h11.494v-9.294H9.689v-3.621h3.129V8.41c0-3.099 1.894-4.785 4.659-4.785 1.325 0 2.464.097 2.796.141v3.24h-1.921c-1.5 0-1.792.721-1.792 1.771v2.311h3.584l-.465 3.63H16.56V24h6.115c.733 0 1.325-.592 1.325-1.324V1.324C24 .593 23.408 0 22.676 0"/>
        </g>
      )
  }
}

class InstagramIcon extends React.Component {
  render(){

    return(
        <g fill={this.props.color} >
          <path d="M12 0C8.74 0 8.333.015 7.053.072 5.775.132 4.905.333 4.14.63c-.789.306-1.459.717-2.126 1.384S.935 3.35.63 4.14C.333 4.905.131 5.775.072 7.053.012 8.333 0 8.74 0 12s.015 3.667.072 4.947c.06 1.277.261 2.148.558 2.913.306.788.717 1.459 1.384 2.126.667.666 1.336 1.079 2.126 1.384.766.296 1.636.499 2.913.558C8.333 23.988 8.74 24 12 24s3.667-.015 4.947-.072c1.277-.06 2.148-.262 2.913-.558.788-.306 1.459-.718 2.126-1.384.666-.667 1.079-1.335 1.384-2.126.296-.765.499-1.636.558-2.913.06-1.28.072-1.687.072-4.947s-.015-3.667-.072-4.947c-.06-1.277-.262-2.149-.558-2.913-.306-.789-.718-1.459-1.384-2.126C21.319 1.347 20.651.935 19.86.63c-.765-.297-1.636-.499-2.913-.558C15.667.012 15.26 0 12 0zm0 2.16c3.203 0 3.585.016 4.85.071 1.17.055 1.805.249 2.227.415.562.217.96.477 1.382.896.419.42.679.819.896 1.381.164.422.36 1.057.413 2.227.057 1.266.07 1.646.07 4.85s-.015 3.585-.074 4.85c-.061 1.17-.256 1.805-.421 2.227-.224.562-.479.96-.899 1.382-.419.419-.824.679-1.38.896-.42.164-1.065.36-2.235.413-1.274.057-1.649.07-4.859.07-3.211 0-3.586-.015-4.859-.074-1.171-.061-1.816-.256-2.236-.421-.569-.224-.96-.479-1.379-.899-.421-.419-.69-.824-.9-1.38-.165-.42-.359-1.065-.42-2.235-.045-1.26-.061-1.649-.061-4.844 0-3.196.016-3.586.061-4.861.061-1.17.255-1.814.42-2.234.21-.57.479-.96.9-1.381.419-.419.81-.689 1.379-.898.42-.166 1.051-.361 2.221-.421 1.275-.045 1.65-.06 4.859-.06l.045.03zm0 3.678c-3.405 0-6.162 2.76-6.162 6.162 0 3.405 2.76 6.162 6.162 6.162 3.405 0 6.162-2.76 6.162-6.162 0-3.405-2.76-6.162-6.162-6.162zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm7.846-10.405c0 .795-.646 1.44-1.44 1.44-.795 0-1.44-.646-1.44-1.44 0-.794.646-1.439 1.44-1.439.793-.001 1.44.645 1.44 1.439z"/>
        </g>
      )
  }
}

class TwitterIcon extends React.Component {
  render(){

    return(
        <g fill={this.props.color} >
          <path d="M23.954 4.569c-.885.389-1.83.654-2.825.775 1.014-.611 1.794-1.574 2.163-2.723-.951.555-2.005.959-3.127 1.184-.896-.959-2.173-1.559-3.591-1.559-2.717 0-4.92 2.203-4.92 4.917 0 .39.045.765.127 1.124C7.691 8.094 4.066 6.13 1.64 3.161c-.427.722-.666 1.561-.666 2.475 0 1.71.87 3.213 2.188 4.096-.807-.026-1.566-.248-2.228-.616v.061c0 2.385 1.693 4.374 3.946 4.827-.413.111-.849.171-1.296.171-.314 0-.615-.03-.916-.086.631 1.953 2.445 3.377 4.604 3.417-1.68 1.319-3.809 2.105-6.102 2.105-.39 0-.779-.023-1.17-.067 2.189 1.394 4.768 2.209 7.557 2.209 9.054 0 13.999-7.496 13.999-13.986 0-.209 0-.42-.015-.63.961-.689 1.8-1.56 2.46-2.548l-.047-.02z"/>
        </g>
      )
  }
}

/**
 * This is our custom SVG element, which has reasonable defaults and applies the correct class names. Note that
 * any custom 'id' or 'className' will be applied to the svg element. A base 'cm-svg' class is also defined, which
 * specifies all the reasonable default styles for svgs.
 *
 * PROPS:
 * name (req.) -> the 'name' of the icon. The svg will receive an 'icon-{name}' class
 * viewBox (opt.) -> Overrides the base viewBox prop
 */
export class CMSvg extends React.Component {
  render(){
    return <svg
      id={this.props.id}
      className={"cm-svg icon-" + this.props.name + (this.props.className ? " " + this.props.className : "")}
      viewBox={this.props.viewBox || "0 0 200 200"}
      width={this.props.width}
      height={this.props.height}
      style={this.props.style}
      {...defaultSVGProps}>
        {this.props.children}
      </svg>
  }

}

/**
 * Arrow icon.
 *
 * Props:
 * reverse {default: False} -> Specifies if the arrow should be going to the right or left. Default is right.
 */
export class ArrowIcon extends React.Component {

  render(){
    let props = Object.assign({}, this.props)
    if (this.props.reverse){
      props.className = (props.className || "") + " reverse"
    }

    return (
      <CMSvg name="arrow" {...props} viewBox="48 82 90 20">
        <g>
          <line className="st0" x1="48" y1="92" x2="136.2" y2="92"/>
          <polyline className="st0" points="128,82.8 136.2,92 128,101.1 "/>
        </g>
      </CMSvg>
    )
  }
}


/**
 * Check mark
 */
export class CheckMarkIcon extends React.Component {

  render(){
    return (
      <CMSvg name="check-mark" {...this.props} viewBox="17 15 10 17">
        <g>
          <path d="M25.38,19.86l-5,9.17.79-.1-2.48-2.48a.5.5,0,0,0-.71.71l2.48,2.48a.51.51,0,0,0,.79-.1l5-9.18c.31-.56-.55-1.07-.86-.5Z"/>
        </g>
      </CMSvg>
    )
  }
}

export class CheckMarkCircledIcon extends React.Component {
  render(){
    return (
      <CMSvg name="check-mark-circled" {...this.props} viewBox="15 15 19 19">
        <g>
          <circle className="check-mark-circled-border" cx="24.45" cy="23.93" r="8.46"/>
          <path className="check-mark-circled-check" d="M27.48,19.88l-4.23,7.73.59-.08-2.48-2.48a.38.38,0,0,0-.53.53l2.48,2.48A.37.37,0,0,0,23.9,28l4.23-7.72c.23-.42-.42-.8-.65-.38Z"/>
        </g>
      </CMSvg>
    )
  }
}

export class CancelCircledIcon extends React.Component {
  render(){
    return (
      <CMSvg name="cancel-circled" {...this.props} viewBox="6 8 30 30">
        <g>
          <circle className="cancel-circled-outer" cx="21.06" cy="22.98" r="12.89"/>
          <path d="M16,18.47,25.57,28c.34.34.88-.19.53-.53l-9.55-9.55a.38.38,0,0,0-.53.53Z"/>
          <path d="M16.55,28l9.55-9.55c.35-.34-.19-.87-.53-.53L16,27.49a.38.38,0,0,0,.53.53Z"/>
        </g>
      </CMSvg>
    )
  }
}

export class PinterestIcon extends React.Component {
  render(){
    return (
      <CMSvg name="pinterest" {...this.props} viewBox="0 0 24 24">
        <g>
          <path d="M0 12c0 5.123 3.211 9.497 7.73 11.218-.11-.937-.227-2.482.025-3.566.217-.932 1.401-5.938 1.401-5.938s-.357-.715-.357-1.774c0-1.66.962-2.9 2.161-2.9 1.02 0 1.512.765 1.512 1.682 0 1.025-.653 2.557-.99 3.978-.281 1.189.597 2.159 1.769 2.159 2.123 0 3.756-2.239 3.756-5.471 0-2.861-2.056-4.86-4.991-4.86-3.398 0-5.393 2.549-5.393 5.184 0 1.027.395 2.127.889 2.726a.36.36 0 0 1 .083.343c-.091.378-.293 1.189-.332 1.355-.053.218-.173.265-.4.159-1.492-.694-2.424-2.875-2.424-4.627 0-3.769 2.737-7.229 7.892-7.229 4.144 0 7.365 2.953 7.365 6.899 0 4.117-2.595 7.431-6.199 7.431-1.211 0-2.348-.63-2.738-1.373 0 0-.599 2.282-.744 2.84-.282 1.084-1.064 2.456-1.549 3.235C9.584 23.815 10.77 24 12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12"/>
        </g>
      </CMSvg>
    )
  }
}

export function ExpandMoreIcon(props) {
  return <CMSvg viewBox="0 -960 960 960" height={props.height || "24" } width={ props.width || "24"}>
    <path fill={props.color} d="M480-345 240-585l56-56 184 184 184-184 56 56-240 240Z"/>
  </CMSvg>
}

export function SearchCheckIcon({color="#6B92B5"}) {
  return <svg viewBox="0 0 48 49" xmlns="http://www.w3.org/2000/svg">
    <path fill={color} d="M15.8667 24.1737L9.4 17.7737L12.2 14.9737L15.8 18.5737L22.4667 11.907L25.2667 14.707L15.8667 24.1737ZM44.2667 48.707L27.4667 31.907C26.1333 32.9737 24.6 33.8181 22.8667 34.4404C21.1333 35.0626 19.2889 35.3737 17.3333 35.3737C12.4889 35.3737 8.38889 33.6959 5.03333 30.3404C1.67778 26.9848 0 22.8848 0 18.0404C0 13.1959 1.67778 9.09592 5.03333 5.74037C8.38889 2.38481 12.4889 0.707031 17.3333 0.707031C22.1778 0.707031 26.2778 2.38481 29.6333 5.74037C32.9889 9.09592 34.6667 13.1959 34.6667 18.0404C34.6667 19.9959 34.3556 21.8404 33.7333 23.5737C33.1111 25.307 32.2667 26.8404 31.2 28.1737L48 44.9737L44.2667 48.707ZM17.3333 30.0404C20.6667 30.0404 23.5 28.8737 25.8333 26.5404C28.1667 24.207 29.3333 21.3737 29.3333 18.0404C29.3333 14.707 28.1667 11.8737 25.8333 9.54037C23.5 7.20703 20.6667 6.04036 17.3333 6.04036C14 6.04036 11.1667 7.20703 8.83333 9.54037C6.5 11.8737 5.33333 14.707 5.33333 18.0404C5.33333 21.3737 6.5 24.207 8.83333 26.5404C11.1667 28.8737 14 30.0404 17.3333 30.0404Z" />
  </svg>
}
